import React from "react";
import Chart from "react-google-charts";
import Typography from "@material-ui/core/Typography";
import Gist from "react-gist";
import { withStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const Gantt = props => {
  const { classes } = props;
  return (
    <div style={{ width: "100%" }}>
      <Typography variant="h5" color="primary">Gantt Chart</Typography>
      <Typography variant="h6">react-google-charts</Typography>
      <Typography className={classes.para} paragraph>
        A Gantt chart is a type of chart that illustrates the breakdown of a
        project into its component tasks. Google Gantt charts illustrate the
        start, end, and duration of tasks within a project, as well as any
        dependencies a task may have. I looked for reactjs components to use
        Google Gantt charts in my website. I found{" "}
        <Link color="secondary" href={"http://react-google-charts.com/"}>
          react-google-charts
        </Link>
        . This offers a declarative API to render{" "}
        <Link color="secondary"
          href={
            "https://developers.google.com/chart/interactive/docs/gallery/ganttchart"
          }
        >
          Google charts
        </Link>
        .
      </Typography>
      <Chart
        width={"100%"}
        height={"300px"}
        chartType="Gantt"
        loader={<div>Loading Chart</div>}
        data={[
          [
            { type: "string", label: "Task ID" },
            { type: "string", label: "Task Name" },
            { type: "date", label: "Start Date" },
            { type: "date", label: "End Date" },
            { type: "number", label: "Duration" },
            { type: "number", label: "Percent Complete" },
            { type: "string", label: "Dependencies" }
          ],
          [
            "Research",
            "Find sources",
            new Date(2015, 0, 1),
            new Date(2015, 0, 5),
            null,
            100,
            null
          ],
          [
            "Write",
            "Write paper",
            null,
            new Date(2015, 0, 9),
            3 * 24 * 60 * 60 * 1000,
            25,
            "Research,Outline"
          ],
          [
            "Cite",
            "Create bibliography",
            null,
            new Date(2015, 0, 7),
            1 * 24 * 60 * 60 * 1000,
            20,
            "Research"
          ],
          [
            "Complete",
            "Hand in paper",
            null,
            new Date(2015, 0, 10),
            1 * 24 * 60 * 60 * 1000,
            0,
            "Cite,Write"
          ],
          [
            "Outline",
            "Outline paper",
            null,
            new Date(2015, 0, 6),
            1 * 24 * 60 * 60 * 1000,
            100,
            "Research"
          ]
        ]}
        rootProps={{ "data-testid": "1" }}
      />
      <Typography className={classes.para} paragraph>
        The code for creating the above chart is as follows.
      </Typography>
      <Gist id="45e6377ad6134aad2d106db90f3855a5" file="Gnatt.jsx" />
      <Typography variant="h5" color="primary">Issue Board</Typography>
      <Typography className={classes.para} paragraph>
        I'm making use of 'Issue Board' of gitlab to manage my project tasks
        effectively.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./WebDev/Screenshot_9.png"
          alt="Schematic"
        />
      </div>{" "}
      <Typography className={classes.para} paragraph>
        Even for group project I deployed SCRUM
        <Link color="secondary"
          href="https://gitlab.com/manojsahukar/make-a-machine/boards/998418"
          target="_blank"
        >
          SCRUM
        </Link>{" "}
        in gitlab.com for managing and tracking individual responsibilities
        where I act as SCRUM Master.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./WebDev/Screenshot_10.png"
          alt="Schematic"
        />
      </div>{" "}
      <Typography variant="h5" color="primary">Spiral Development</Typography>
      <Typography className={classes.para} paragraph>
        I find Spiral development an excellent tool for managing expectations
        and anxiety during project execution. This framework suggests to get to
        final project through small intermediary steps by developing working
        prototypes in each step.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="https://upload.wikimedia.org/wikipedia/commons/e/ec/Spiral_model_%28Boehm%2C_1988%29.svg"
          alt="Spiral Development"
        />
      </div>{" "}
      <Typography align="center" className={classes.para} paragraph>
        Source:{" "}
        <Link color="secondary" target="_blank" href="https://en.wikipedia.org/wiki/Spiral_model">
          Wikipedia - Spiral model
        </Link>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Gantt);
